import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';
import { palette } from '../../../Dashboard.styled';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-top: 12px;
`;

export const Tile = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 14px;
  border: 1px solid ${palette.border};
  border-radius: 12px;
  background: ${colors.WHITE};
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px) scale(1.03);
    border-color: ${palette.green};
    box-shadow: 0 8px 20px rgba(18, 33, 26, 0.1);
  }
`;

export const TileTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${palette.ink};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
